import { Axis } from './Axis.js';
import { AXIS_LABEL_HEIGHT } from './constants.js';
import { OrientedAxisProps } from './types.js';

/**
 * @internal
 */
export function AxisLeft({
  scale,
  label,
  width,
  ...restAxisProps
}: OrientedAxisProps) {
  // oxlint-disable-next-line typescript/no-non-null-assertion
  const labelOffset = width! - AXIS_LABEL_HEIGHT;

  return (
    <Axis
      orientation="left"
      width={width}
      height={restAxisProps.containerSize}
      label={label}
      scale={scale}
      labelOffset={labelOffset}
      left={width}
      {...restAxisProps}
    />
  );
}

AxisLeft['displayName'] = 'AxisLeft';
